import { createContext, useContext, useMemo } from 'react';
import type { MainLayoutContextType } from './types';
import { useIsMobile } from '@ibsys/kit';

export const MainLayoutContext = createContext<MainLayoutContextType | undefined>(undefined);

export const useMainLayout = (): MainLayoutContextType & { isMobile: boolean } => {
  const ctx = useContext(MainLayoutContext);
  const isMobile = useIsMobile();

  if (!ctx) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider');
  }

  return useMemo(
    () => ({
      ...ctx,
      isMobile,
    }),
    [ctx, isMobile],
  );
};
